import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';
import { BgImage } from 'gbimage-bridge';

const Background = styled.div`
  background-image: ${({ image }) => `url(${image})`};
  background-size: ${({ size }) => size || 'cover'};
  background-position: ${({ position }) => position || 'center'};
  background-repeat: ${({ repeat }) => repeat || 'no-repeat'};
`;

const GatsbyBackground = styled(BgImage)`
  background-size: ${({ size }) => size || 'cover'};
  background-position: ${({ position }) => position || 'center'};
  background-repeat: ${({ repeat }) => repeat || 'no-repeat'};
`;

export default function GatsbyBackgroundImage({
  src,
  overlay = [],
  children,
  ...rest
}) {
  const { images } = useStaticQuery(graphql`
    query {
      images: allFile(
        filter: {
          internal: { mediaType: { regex: "/image/" } }
          extension: { ne: "svg" }
        }
      ) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP]
              width: 1920
            )
          }
        }
      }
    }
  `);

  const match = images.nodes.find((node) => src.includes(node.name));
  const extension = src.split('.').pop();

  if (extension === 'svg') {
    return (
      <Background image={src} {...rest}>
        {children}
      </Background>
    );
  }

  if (!match) return null;

  return (
    <GatsbyBackground image={[...overlay, getImage(match)]} {...rest}>
      {children}
    </GatsbyBackground>
  );
}
